export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10848.8760b532.jpg";